import * as React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

import "./index.css";

interface IProps {
  title: string;
  modalDisplay: any;
  modal: boolean;
  toggleModal(): void;
}

const GlobalModal: React.SFC<IProps> = props => {
  return (
    <div>
      <Modal isOpen={props.modal} toggle={props.toggleModal}>
        <ModalHeader toggle={props.toggleModal}>{props.title}</ModalHeader>
        <ModalBody>{props.modalDisplay}</ModalBody>
      </Modal>
    </div>
  );
};

export default GlobalModal;



// WEBPACK FOOTER //
// ./src/Components/GlobalModal/index.tsx